(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/models/betslip.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/models/betslip.js'); 
'use strict';

svs.maltipset.models.Betslip = Backbone.Model.extend({
  initialize: function() {
    this.setModelData(true);
    this.listenTo(this.get('coupon'), 'xpert:doneLoad', this.couponChanged);
    this.listenTo(
      this.get('coupon'),
      'change:totalCost change:totalCompleteRows',
      this.couponChanged
    );
  },
  setModelData: function(silent) {
    var betslipData = this.generateBetslipData();
    this.set(
      {
        boardData: betslipData,
        noOfMatches: _.countBy(betslipData, function(board) {
          return board !== undefined;
        }).true,
        noOfRows: this.get('coupon').get('totalCompleteRows'),
        system: this.get('coupon').get('system'),
        isSystem: this.get('coupon').isMOrRSystem()
      },
      { silent: silent }
    );
  },
  couponChanged: function() {
    this.setModelData(false);
  },
  generateBetslipData: function() {
    var boardData = this.get('coupon').getBoardData(false);
    var matchList = this.get('coupon')
      .get('draw')
      .get('matchList');
    var betslipBoard = [];

    matchList.each(function(match, matchIndex) {
      if (match.get('matchesMarked') > 0) {
        var data = {
          match: match.toJSON(),
          matchIndex: matchIndex,
          matchNumber: match.get('eventNumber'),
          inRow: []
        };
        var found = false;

        _.each(boardData, function(row) {
          if (row.indexOf(match.get('eventNumber')) >= 0) {
            data.inRow.push(1);
            found = true;
          } else {
            data.inRow.push(0);
          }
        });

        if (found) {
          betslipBoard.push(data);
        }
      }
    });

    return betslipBoard;
  }
});

 })(window);